module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Servers",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "owner-group"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Type to Search"
    },
    on: {
      "input": function($event) {
        return _vm.pageChange()
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "to": "/servers/add"
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "display-mode",
      "options": _vm.displayModeOptions,
      "buttons": "",
      "button-variant": "outline-primary",
      "name": "display-mode"
    },
    model: {
      value: (_vm.displayMode),
      callback: function($$v) {
        _vm.displayMode = $$v
      },
      expression: "displayMode"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.displayMode === 'table') ? _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Group")]), _vm._v(" "), _c('th', [_vm._v("Hostname")]), _vm._v(" "), _c('th', [_vm._v("RAM")]), _vm._v(" "), _c('th', [_vm._v("Disk")]), _vm._v(" "), _c('th', [_vm._v("Color")]), _vm._v(" "), _c('th', [_vm._v("Visible")]), _vm._v(" "), _c('th', [_vm._v("Enabled")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('b-link', {
      on: {
        "click": function($event) {
          return _vm.viewServer(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.group))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.hostname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("size")(item.metrics.memory.free)) + " / " + _vm._s(_vm._f("size")(item.metrics.memory.free + item.metrics.memory.used)) + " (" + _vm._s(_vm._f("percentage")(item.metrics.memory.usage)) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("size")(item.metrics.disk.free)) + " / " + _vm._s(_vm._f("size")(item.metrics.disk.free + item.metrics.disk.used)) + " (" + _vm._s(_vm._f("percentage")(item.metrics.disk.usage)) + ")")]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "color",
        "readonly": true,
        "disabled": true
      },
      model: {
        value: (item.color),
        callback: function($$v) {
          _vm.$set(item, "color", $$v)
        },
        expression: "item.color"
      }
    })], 1), _vm._v(" "), _c('td', [(item.visible == true) ? _c('icon', {
      attrs: {
        "name": "eye"
      }
    }) : _vm._e(), _vm._v(" "), (item.visible == false) ? _c('icon', {
      attrs: {
        "name": "eye-slash"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.enabled == true) ? _c('icon', {
      attrs: {
        "name": "check"
      }
    }) : _vm._e(), _vm._v(" "), (item.enabled == false) ? _c('icon', {
      attrs: {
        "name": "ban"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": item.status === 'RUNNING' ? 'success' : ''
      }
    }, [_vm._v(_vm._s(item.status))])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_c('b-button-toolbar', [_c('b-button-group', [(item.visible == false) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Show"
      },
      on: {
        "click": function($event) {
          return _vm.setVisible(item.id, true)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "eye"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.visible == true) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Hide"
      },
      on: {
        "click": function($event) {
          return _vm.setVisible(item.id, false)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "eye-slash"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.enabled == false) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Enable"
      },
      on: {
        "click": function($event) {
          return _vm.setEnable(item.id, true)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.enabled == true) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Disable"
      },
      on: {
        "click": function($event) {
          return _vm.setEnable(item.id, false)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "ban"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "disabled": item.enabled == false,
        "title": "Start"
      },
      on: {
        "click": function($event) {
          return _vm.startMonitor(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "play"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "disabled": item.enabled == false,
        "title": "Stop"
      },
      on: {
        "click": function($event) {
          return _vm.stopMonitor(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "stop"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Refresh"
      },
      on: {
        "click": function($event) {
          return _vm.refreshServer(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "sync"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteServer(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "trash"
      }
    })], 1)], 1)], 1)], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'list') ? _c('b-list-group', _vm._l((_vm.items), function(item) {
    return _c('b-list-group-item', {
      on: {
        "click": function($event) {
          return _vm.viewServer(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('h5', {
      staticClass: "mb-1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('small', [(item.visible == true) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "eye",
        "title": "Visible"
      }
    }) : _vm._e(), _vm._v(" "), (item.visible == false) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "eye-slash",
        "title": "Hidden"
      }
    }) : _vm._e(), _vm._v(" "), (item.enabled == true) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "check",
        "title": "Enabled"
      }
    }) : _vm._e(), _vm._v(" "), (item.enabled == false) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "ban",
        "title": "Disabled"
      }
    }) : _vm._e(), _vm._v(" "), _c('b-badge', {
      attrs: {
        "variant": item.status === 'RUNNING' ? 'success' : ''
      }
    }, [_vm._v(_vm._s(item.status))])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "mb-1"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.description) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "float-right"
    }, [_c('b-button-toolbar', [_c('b-button-group', [_c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "size": "sm",
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteServer(item.id)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash"
      }
    })], 1)], 1)], 1)], 1)])
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row mt-3"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.totalItems) + " Servers")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": _vm.totalItems,
      "per-page": _vm.rowsPerPage
    },
    on: {
      "input": function($event) {
        return _vm.pageChange()
      }
    },
    model: {
      value: (_vm.pageNo),
      callback: function($$v) {
        _vm.pageNo = $$v
      },
      expression: "pageNo"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-form-select', {
    attrs: {
      "options": [{
        text: 10,
        value: 10
      }, {
        text: 25,
        value: 25
      }, {
        text: 50,
        value: 50
      }, {
        text: 100,
        value: 100
      }]
    },
    on: {
      "input": function($event) {
        return _vm.pageChange()
      }
    },
    model: {
      value: (_vm.rowsPerPage),
      callback: function($$v) {
        _vm.rowsPerPage = $$v
      },
      expression: "rowsPerPage"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-467d9651","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/servers/ServersPage.vue
// module id = 2142
// module chunks = 1